import getBG from '../../utils/utils';

export default {
    name: 'iphone-product',
    data() {
        return {
            products: [],
            backgroundImage: '',
            headerImage: ''
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.getMobileProduct();
            this.backgroundImage = await getBG.call(this, 'MobileProducts');
            this.headerImage = await getBG.call(this, 'Products');
        },
        // 查移动产品
        getMobileProduct() {
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    contentType: 'MobileProducts'
                })
                .then(res => {
                    this.products = res.map(item => {
                        item.image = this.$config.baseUrl + item.image;
                        return item;
                    });
                    console.log(res);
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        },
        go(path, item) {
            const { href } = this.$router.resolve({
                path: path,
                query: {
                    id: item.id,
                    purposeType: 'MobileProducts'
                }
            });

            window.open(href, '_blank');
        }
    }
};
